import {ClockCircleOutlined} from '@ant-design/icons';
import styles from './AwaitingReplyBadge.module.scss';

/**
 * "Customer replied" marker for a ticket waiting on its agent (see
 * formatAwaitingReply). `strip` spans a card; `pill` sits under a name in the
 * table / chat list.
 */
export const AwaitingReplyBadge = ({awaiting, variant = 'pill'}) => {
  if (!awaiting) return null;
  const tone = styles[awaiting.color] || '';
  const title = `Customer replied and has been waiting ${awaiting.label}`;

  if (variant === 'strip') {
    return (
      <div className={`${styles.strip} ${tone}`} title={title}>
        <span className={styles.lead}>
          <span className={styles.dot} />
          Customer replied
        </span>
        <span className={styles.wait}>
          <ClockCircleOutlined /> {awaiting.label}
        </span>
      </div>
    );
  }

  return (
    <span className={`${styles.pill} ${tone}`} title={title}>
      <span className={styles.dot} />
      Replied · {awaiting.label}
    </span>
  );
};
